module.exports = __webpack_public_path__ + "4398abb2bdfd336f38cd974f5bc298c4.pdf";